document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');
  let lastScrollY = window.scrollY;
  let scrollTimeout;
  
  const updateHeights = () => {
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    if (header) {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
  };
  
  updateHeights();
  window.addEventListener('resize', updateHeights);
  
  function controlHeader() {
    const currentScrollY = window.scrollY;
    
    // Añadir/remover clase scrolled basado en la posición del scroll
    if (currentScrollY > 150) {
      header.classList.add('scrolled');
    } else if (currentScrollY <= 0) {
      // Asegurarse de remover la clase cuando estamos en el top
      header.classList.remove('scrolled');
    } else if (currentScrollY < 150) {
      header.classList.remove('scrolled');
    }
    
    // No ocultar el header si un drawer está abierto
    if (!header.classList.contains('drawer-is-open')) {
      // Ocultar/mostrar header solo si no hay drawer abierto
      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        header.classList.add('header--hidden');
        if (announcementBar) {
          announcementBar.classList.add('announcement--hidden');
        }
      } else {
        header.classList.remove('header--hidden');
        if (announcementBar) {
          announcementBar.classList.remove('announcement--hidden');
        }
      }
    } else {
      // Si hay un drawer abierto, asegurarse que el header sea visible
      header.classList.remove('header--hidden');
      if (announcementBar) {
        announcementBar.classList.remove('announcement--hidden');
      }
    }
    
    lastScrollY = currentScrollY;

    // Limpiar el timeout anterior
    clearTimeout(scrollTimeout);
    
    // Establecer un nuevo timeout para verificar cuando el scroll se detiene
    scrollTimeout = setTimeout(() => {
      // Verificar una última vez la posición cuando el scroll se detiene
      if (window.scrollY <= 0) {
        header.classList.remove('scrolled');
      }
    }, 150); // 150ms después de que el scroll se detiene
  }
  
  // Usar requestAnimationFrame para optimizar el rendimiento
  let ticking = false;
  
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        controlHeader();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Verificar la posición inicial
  if (window.scrollY <= 0) {
    header.classList.remove('scrolled');
  }

  // Eliminar el event listener antiguo de los toggles
  // const mobileToggles = document.querySelectorAll('.mobile-menu__toggle');
  
  // Mantener solo el listener del botón completo
  const titleButtons = document.querySelectorAll('.mobile-menu__title-button');
  
  titleButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      const toggle = this.querySelector('.mobile-menu__toggle');
      if (!toggle) return;
      
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      
      const submenu = this.closest('.mobile-menu__item').querySelector('.mobile-submenu');
      if (submenu) {
        submenu.style.maxHeight = !isExpanded ? `${submenu.scrollHeight}px` : '0';
      }
    });
  });
});
